import { LayoutDashboard, Building2, Package, ShoppingCart } from "lucide-react";
import PortalLayout from "@/components/portal/PortalLayout";

const LINKS = [
  { to: "/mall-owner", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/mall-owner/malls", label: "Malls", icon: Building2 },
  { to: "/mall-owner/inventory", label: "Inventory", icon: Package },
  { to: "/mall-owner/bookings", label: "Bookings", icon: ShoppingCart },
];

export default function MallOwnerLayout() {
  return <PortalLayout title="Mall Admin" links={LINKS} allowedRoles={["mall_owner", "super_admin"]} testId="mall-owner-portal" />;
}
